var map = {
	"./3BoxProfile.js": 620,
	"./BurnerWallet.js": 621,
	"./Chain.js": 622,
	"./Chess.js": 623,
	"./Create2.js": 638,
	"./DAI.js": 641,
	"./ENS.js": 649,
	"./ERC20Token.js": 650,
	"./GasPrice.js": 651,
	"./MetaMask.js": 652,
	"./OpenSea.js": 654,
	"./Permit.js": 655,
	"./Price.js": 656,
	"./RadarRelay.js": 657,
	"./TestFaucet.js": 658,
	"./TypedData.js": 659,
	"./Uniswap.js": 660,
	"./WETH.js": 661,
	"./Wallet.js": 662,
	"./WispBootstrap.js": 663,
	"./index.js": 438
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2560;